;(function($){

    function Schedule_calendar()
    {
        var _ = this;

        _.API  = $("#app_url").val() + "/api/";
        _.data = [];

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        $("#btn-calendar-filter").on("click", function(e){
            _.data = [];

            _.getData();
        }); 

        if ($('#schedule-calendar').length > 0) {
            _.getData(); 
        }            
    }

    Schedule_calendar.prototype.getCalendar =  function() {
        
        var _ =  this;

        if($("#modal-schedule-calendar").length > 0) {

            $("#modal-schedule-calendar").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                eventOverlap: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();              
                },
                onClosed: function() {
                    _.html         = null;
                    $("#modal-schedule-calendar .content").html("");
                    $('#modal-schedule-calendar').iziModal('setTitle', "");
                }        
            });
        }

        
        $('#schedule-calendar').fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listWeek'
            },
            defaultDate: new Date(),
            locale: 'pt-br',
            navLinks: true, 
            editable: false,
            eventLimit: true,
            events: _.data, 
            eventClick: function(info) {
                var html = '<div>';
                    html += '<ul class="list-group">';
                    html += '<li class="list-group-item"><strong>Nº Tarefa: </strong>'+info.data.schedule_id+'</li>';
                    html += '<li class="list-group-item"><strong>Nº Ticket: </strong>'+info.data.tickets_id+'</li>';
                    html += '<li class="list-group-item"><strong>Cliente: </strong>'+info.data.customer+'</li>';
                    html += '<li class="list-group-item"><strong>Analista: </strong>'+info.data.user_name+'</li>';  
                    html += '<li class="list-group-item"><strong>Horas Previstas: </strong>'+info.data.expected_hours+'</li>';                  
                    html += '<li class="list-group-item"><strong>Horas Apontadas: </strong>'+info.data.hours+'</li>';
                    html += '<li class="list-group-item"><strong>Data: </strong>'+info.data.start+' até '+ info.data.end+' </li>';
                    html += '<li class="list-group-item"><strong>Status: </strong>'+info.data.status+'</li>';
                    html += '<li class="list-group-item"><strong>Descrição: </strong>'+info.data.text+'</li>';                    
                    html += '</ul>';
                html += '</div>';

                $('#modal-schedule-calendar').iziModal('setTitle', '<i class="fa fa-calendar" aria-hidden="true"></i> Tarefa ( ' + info.data.schedule_id+' ) - '+info.data.user_name);
                $("#modal-schedule-calendar .content").html(html);                

                $('#modal-schedule-calendar').iziModal('open'); 
            }
        });

        $('.fc-scroller').css('overflow','visible');
    }

    Schedule_calendar.prototype.getData = function() {

        $('#schedule-calendar').fullCalendar('destroy');

        var _               =  this
        _.filter_users_id   = $("#filter_users_id").val();
        _.filter_customers  = $("#customers_id").val();
        _.filter_tickets_id = $("#tickets_id").val();
        _.filter_status     = $("#filter_status").val();
        _.filter_start_date = $("#filter_start_date").val();
        _.filter_end_date   = $("#filter_end_date").val();

        _.filter_users_id   = (_.filter_users_id) ?  _.filter_users_id : '';
        _.filter_customers  = ( _.filter_customers) ? _.filter_customers : '';
        _.filter_tickets_id = (_.filter_tickets_id) ? _.filter_tickets_id : '';
        _.filter_status     = (_.filter_status) ? _.filter_status : '';
        _.filter_start_date = (_.filter_start_date) ? _.filter_start_date : '';
        _.filter_end_date   = (_.filter_end_date) ?  _.filter_end_date : '';

        $.get(this.API + "agenda/painel/tarefas?filter_users_id="+_.filter_users_id+"&filter_customers="+_.filter_customers+"&filter_tickets_id="+_.filter_tickets_id+"&filter_status="+_.filter_status+"&filter_start_date="+_.filter_start_date+"&filter_end_date="+_.filter_end_date+"", function(data)
        {
            _.data = data; 
            $('#schedule-calendar').fullCalendar('destroy');           
        }).done(function(){
            _.getCalendar();  
        }); 
    };

   	new Schedule_calendar();
}(jQuery));
 
 
 
 
